import { useDroppable } from "@dnd-kit/core";
import { useTranslation } from "react-i18next";
import { List } from "semantic-ui-react";

import { LocationServiceItem } from "modules/CheckInServices/components/LocationServicesList/components";
import { useLocationCheckInServicesQuery, useTagsQuery } from "modules/CheckInServices/components/LocationServicesList/hooks";

import type { CheckInService } from "models";

type LocationServicesListProps = {
  onServiceClick: (service: CheckInService) => void;
};

export const LocationServicesList = ({ onServiceClick }: LocationServicesListProps) => {
  const { t } = useTranslation();

  const { data: locationServices = [] } = useLocationCheckInServicesQuery();
  const { data: tags = [] } = useTagsQuery();
  const { setNodeRef, isOver } = useDroppable({ id: "CheckInLocationServices" });

  return (
    <>
      <div className="services-header">
        <h3>{t("v8_location_services", "Location Services")}</h3>
      </div>

      <div ref={setNodeRef} className="services-list-container">
        <List divided relaxed>
          {locationServices.map(service => (
            <LocationServiceItem key={service.id} service={service} tags={tags} onClick={onServiceClick} />
          ))}
        </List>

        {isOver && <div className="drop-placeholder" />}
      </div>
    </>
  );
};
